module.exports = __webpack_public_path__ + "img/tokuten_ico2.b29d9a27.png";